import { render, staticRenderFns } from "./TableSkeleton.vue?vue&type=template&id=600cb5ac"
import script from "./TableSkeleton.vue?vue&type=script&lang=js"
export * from "./TableSkeleton.vue?vue&type=script&lang=js"
import style0 from "./TableSkeleton.vue?vue&type=style&index=0&id=600cb5ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports